import React, { Component } from "react";
import { connect } from "react-redux";
import { Card, Grid, Icon, Segment } from "semantic-ui-react";
import MainButton from "components/Buttons/MainButton";
import { getTerminalsByCenter } from "services/payment";
import { pay, getPaymentStatus } from "utils/servipay";
import { Form, Formik } from "formik";
import PaymentForm from "features/Admin/Payment/PaymentForm";
// import CustomInputTextComponent from 'components/Form/CustomInputTextComponent';
import * as Yup from "yup";
// import LogPaymentEvent from './LogPaymentEvent';

const schemaValidation = Yup.object().shape({
	terminalId: Yup.number().required("Veuillez sélectionner un terminal de paiement."),
	amount: Yup.number().moreThan(0, "Veuillez entrer un montant positif."),
	communication: Yup.string(),
});

class Payment extends Component {
	constructor(props) {
		super(props);

		this.state = {
			selectedFolder: null,
			logs: [],
		};
	}
	componentDidMount() {
		const { center } = this.props.centers;
		this.props.getTerminalsByCenter(center ? center.id : null);
	}
	updateLogs() {
		const log = getPaymentStatus();
		this.setState({ logs: log });
	}

	payWithServipay = async (values, setSubmitting) => {
		const { terminals } = this.props;
		const terminalUsed = terminals.find((t) => t.tid === values.terminalId);

		pay(terminalUsed.ip, terminalUsed.port, values.amount, values.communication);
		setSubmitting(false);
	};
	render() {
		const { terminals } = this.props;
		// const { logs } = this.state;
		return (
			<div
				style={{
					height: "100vh",
					overflowY: "scroll",
				}}
			>
				<Grid
					className="ui container"
					style={{
						maxHeight: "100vh",
						maxWidth: "90%",
						display: "flex",
						justifyContent: "center",
						paddingTop: 43,
					}}
				>
					<Grid.Row>
						<Card style={{ marginTop: 10, display: "flex", flex: 1 }}>
							<Card.Header style={{ margin: 10, display: "flex", flex: 1 }}>Effectuer un paiement via un terminal Servipay</Card.Header>
							<Card.Content>
								<Segment>
									<Formik
										enableReinitialize
										initialValues={{
											terminalId: 0,
											amount: 0.0,
											communication: "",
										}}
										validationSchema={schemaValidation}
										onSubmit={(values, { setSubmitting }) => {
											this.payWithServipay(values, setSubmitting);
										}}
									>
										{({ isSubmitting, values, errors }) => (
											<Form>
												<Grid style={{ margin: 0 }}>
													<PaymentForm
														terminalsOptions={terminals.map((t) => {
															return { key: t.id, label: t.label, value: t.tid };
														})}
													/>
												</Grid>
												<MainButton
													text={<Icon name="payment" />}
													type="submit"
													style={{ float: "center" }}
													isSubmitting={isSubmitting}
													disabled={values.terminalId === 0}
												>
													Payer
												</MainButton>
											</Form>
										)}
									</Formik>
								</Segment>
								{/* <Segment>
								<MainButton
									text={<Icon name='payment' />}
									type='button'
									onClick={async () => {
										await initTerminal();
									}}
									style={{ float: 'right' }}
								>
									Initialiser le terminal
								</MainButton>
								<MainButton
									text={<Icon name='payment' />}
									type='button'
									onClick={(e) => this.payWithServipay()}
									style={{ float: 'right' }}
								>
									Payer
								</MainButton>
								<MainButton
									text={<Icon name='payment' />}
									type='button'
									onClick={async () => {
										await stop();
									}}
									style={{ float: 'right' }}
								>
									Arrêter le worker
								</MainButton>
								</Segment> 
								<Segment>
									Logs
									<LogPaymentEvent logs={logs} />
								</Segment>*/}
							</Card.Content>
						</Card>
					</Grid.Row>
				</Grid>
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		user: state.user,
		centers: state.centers,
		terminals: state.folderManager.terminals,
	};
};

const mapDispatchToProps = {
	pay,
	getTerminalsByCenter,
};

export default connect(mapStateToProps, mapDispatchToProps)(Payment);
